export default __webpack_public_path__ + "static/logo_footer-94320036aa9202e46dce88696da750d8.png";